import { Analytics } from 'client/Global/Analytics'
import { trackingFields } from 'client/Global/AnalyticsEvents'
import { AddressInterface } from 'client/Interfaces/AddressInterface'
import { CustomerInterface } from 'client/Interfaces/CustomerInterface'

export const addCustomersAnalyticsEvent = (event, result, placement, customerId) => {
  Analytics.trackEvent(event, {
    type: trackingFields.type.action,
    category: trackingFields.category.customer,
    result,
    placement,
    customerId,
  })
}

export const getInvoicesGrossTotal = (id, sales, matchKey) => {
  const matched = sales && sales.find((element) => element.customerId === id)
  return matched && matched.summary && matched.summary[matchKey] && matched.summary[matchKey].grossTotal
    ? matched.summary[matchKey].grossTotal
    : 0
}

export const getFormattedCustomerName = (customer: CustomerInterface, includeTitle: boolean): string => {
  const prefix = includeTitle && customer.title ? `${customer.title} ` : ''
  return customer.customerType === 'c' ? customer.companyName : `${prefix}${customer.firstName} ${customer.lastName}`
}

export const getCombinedAddressLines = (address: AddressInterface | undefined): string => {
  const { streetAddress1, streetAddress2 } = address
  return `${[streetAddress1, streetAddress2].filter(Boolean).join('\n')}`
}

export const getPlansTitleDescription = (activePeriod: string, subStatus: 'free' | 'paid', referal: string) => {
  if (activePeriod === 'year') {
    return {
      titleKey: `subscription.premium-plan.${subStatus}.yearly.title`,
      descKey: `subscription.premium-plan.${subStatus}${referal}.yearly.description`,
    }
  } else if (activePeriod === 'month') {
    return {
      titleKey: `subscription.premium-plan.${subStatus}${referal}.monthly.title`,
      descKey: `subscription.premium-plan.${subStatus}${referal}.monthly.description`,
    }
  }
}

export const getPeriodValues = (
  subStatus: 'Free' | 'Paid',
): {
  automationVal: 'yearly' | 'monthly'
  periodVal: 'year' | 'month'
  keyVal: string
  classVal: '_A' | '_B'
}[] => {
  return [
    { automationVal: 'yearly', periodVal: 'year', keyVal: `yearlyPlans${subStatus}`, classVal: '_B' },
    { automationVal: 'monthly', periodVal: 'month', keyVal: `monthlyPlans${subStatus}`, classVal: '_B' },
  ]
}
